"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var t=function(r){try{return!!r()}catch{return!0}};exports.fails=t;
